module.exports = __webpack_public_path__ + "img/logo-light.30e41965.png";